import { render, staticRenderFns, recyclableRender, components } from "./qualification.vue?vue&type=template&id=77c75734&scoped=true&"
var renderjs
import script from "./qualification.vue?vue&type=script&lang=js&"
export * from "./qualification.vue?vue&type=script&lang=js&"
import style0 from "./qualification.vue?vue&type=style&index=0&id=77c75734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c75734",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/qualification/qualification.vue"
export default component.exports